// will present the last 5 logs with errors,
//   will offer the option to export the last X lines of errors, where the X will be selected by the use
// could offer some filter, like timestamp, or

import { AgGridReact } from "ag-grid-react";
import React, { useMemo } from "react";

interface IIntegraionLogsProps {
  error: any;
}

export const IntegraionLogs = React.memo(({ error }: IIntegraionLogsProps) => {
  const columnDef = useMemo(
    () => [
      {
        field: "model",
        headerName: "Type",
        maxWidth: 120,
        valueGetter: (params: any) =>
          params.data.model === "mpn.oragpcmodel" ? "GPC" : "Item Number",
      },
      {
        field: "pk",
        headerName: "Ora Id",
        minWidth: 150,
        flex:1,
        valueGetter: (params: any) => params.data.pk,
      },
      {
        field: "last_update_date",
        headerName: "Updated At",
        minWidth: 250,
        flex:1,
        valueGetter: (params: any) => new Date(params.data.fields?.last_update_date).toUTCString(),
      },
      {
        field: "last_updated_by",
        headerName: "Updated By",
        minWidth: 150,
        flex:1,
        valueGetter: (params: any) => params.data.fields.last_updated_by,
      },
      {
        field: "error_message",
        headerName: "Error Message",
        flex:2,
        // minWidth: 300,
        valueGetter: (params: any) => params.data.fields.error_message,
      },
    ],
    [],
  );

  const rowData = error;

  return (
    <div className="ag-theme-alpine" style={{ opacity: 0.4, fontSize: '12px !important' }}>
      <AgGridReact
        domLayout="autoHeight"
        rowData={rowData}
        columnDefs={columnDef}
        suppressRowClickSelection
        pagination={false}
        unSortIcon
        suppressPaginationPanel
      />
    </div>
  );
});
